import styled, { css } from 'styled-components';
export const MapExistingContactTabContainer = styled.div.withConfig({
  displayName: "MapExistingContactTabstyle__MapExistingContactTabContainer"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  const styles = css(["[class*='ExpandableContents']{padding-left:", ";padding-right:", ";}[class*='ExpandableHeader']{border-block-start:none;}"], theme.space['100'], theme.space['100']);
  return styles;
});